import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { IProductsFetchFilter } from '../../../api';
import { IProductSearchItem } from '../../../products/models';
import { ProductsService } from '../../../products/products.service';

export interface IProductModel  extends IProductSearchItem {
    IsSelected?: boolean;
}

class SelectProducts implements ng.IController {
    public static $inject = ['$translate', 'productsService', 'notificationService'];

    public resolve: {
        options: {
            selectedProducts: IProductSearchItem[],
            isAllSelected: boolean
        }};

    public total: number = 0;
    public selectedProducts: { [id: string]: IProductModel } = {};

    private modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    private model = {
        addButtonText: 'Add',
        products: [] as IProductModel[],
        searchTerm: null as string,
        waiting: true,
        isAllSelected: false,
        noProductMessage: this.$translate.instant('nfc_select_product_empty_list_message')
    };

    constructor(
        protected $translate: angular.translate.ITranslateService,
        public productService: ProductsService,
        public notificationService: NotificationService
    ) {
    }

    public $onInit() {
        angular.forEach(this.resolve.options.selectedProducts, (product) => this.selectedProducts[product.ID] = product);
        this.model.isAllSelected = this.resolve.options.isAllSelected;
        this.loadProducts();
    }

    public searchKeyPressed($event: KeyboardEvent) {
        if ($event.which === 13 && !this.model.waiting) {
            this.search();
        }
    }

    public loadProducts() {
        if (this.total && this.model.products.length === this.total) {
            return;
        }

        const filter: IProductsFetchFilter = {
            searchTerm: this.model.searchTerm,
            limit: 10,
            searchAfterId: this.model.products.length ? _.last(this.model.products).ID : null
        };

        this.productService.fetchProducts(filter)
            .then((productsResponse) => {

                this.total = productsResponse.Total;
                const products: IProductModel[] = productsResponse.Items;
                products.forEach((product) => {
                    product.ImageUrl = this.productService.getImageUrl(product.ImageID, 60);
                    product.IsSelected = !!this.selectedProducts[product.ID] || this.model.isAllSelected;
                });
                Array.prototype.push.apply(this.model.products, products);
                this.model.waiting = false;

                if (this.model.products.length) {
                    return;
                }

                this.model.noProductMessage = this.model.searchTerm && this.model.searchTerm.length
                    ? this.$translate.instant('product_was_not_found')
                    : this.$translate.instant('nfc_select_product_empty_list_message');
            })
            .catch((error) => this.notificationService.showErrorMessage(error));
    }

    public search() {
        this.total = 0;
        this.model.products = [];
        this.loadProducts();
    }

    public selectProduct(product: IProductModel) {
        product.IsSelected = !product.IsSelected;
        this.setAddButtonText();
    }

    public setAddButtonText() {
        if (this.model.isAllSelected) {
            this.model.products.forEach((item) => item.IsSelected = true);
            this.model.addButtonText = 'Add (All)';
            this.resolve.options.isAllSelected = true;
            return;
        }

        this.resolve.options.isAllSelected = false;
        const selectedProductsCount = this.getSelectedProducts().length;
        this.model.addButtonText = selectedProductsCount > 0 ? `Add (${selectedProductsCount})` : 'Add';
    }

    public getSelectedProducts(): IProductModel[] {
        return this.model.products.filter((item) => item.IsSelected);
    }

    public confirm() {
        const selectionResult = {
            status: 'ok',
            isAllSelected: false,
            selectedProducts: [] as IProductSearchItem[]
        };

        if (this.model.isAllSelected) {
            selectionResult.isAllSelected = true;
            this.modalInstance.close( { $value: selectionResult});
        }

        selectionResult.selectedProducts = this.getSelectedProducts();
        this.modalInstance.close( { $value: selectionResult});
    }

    public dismiss = () => this.modalInstance.close({$value: {status: 'close'}});
}

angular.module('naut').component('selectProducts', {
    template: require('./select-products.component.html'),
    controller: SelectProducts,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/shared/select-products/select-products.component.ts